import PropTypes from 'prop-types';
import React from 'react';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import {
  SelectScenarioContextProvider,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/SelectScenarioContext';
import { RightColumnProvider } from 'Context/RightColumnContext';
import RoadmapExecutiveSummaryStepLayout
  from 'Views/Page/Content/Templates/RoadmapExecutiveSummaryStepTemplate/RoadmapExecutiveSummaryStepLayout';

export default function RoadmapExecutiveSummaryStepTemplate({ resource }) {
  const { loadPageContentLink } = usePageContentContext();

  const onSelectSuccess = async () => {
    // After we submit the scenario successfully we need to make sure we get taken into the scenario wizard.
    // We will take you to the decision step which will then direct you to the correct place
    await resource.withRelationship(fr.relationships.scenarioSelectionDecisionStep.name,
      (decisionStepRel) => loadPageContentLink(decisionStepRel.link('related')),
      () => null);
  };

  return (
    <SelectScenarioContextProvider onSelectSuccess={onSelectSuccess}>
      <RightColumnProvider>
        <RoadmapExecutiveSummaryStepLayout resource={resource} />
      </RightColumnProvider>
    </SelectScenarioContextProvider>
  );
}

RoadmapExecutiveSummaryStepTemplate.defaultProps = {
};

RoadmapExecutiveSummaryStepTemplate.propTypes = {
  resource: PropTypes.object.isRequired,
};
